import { number, largerEq, smaller, sum, subtract, multiply, round, floor } from 'mathjs'
import moment from 'moment'
import Vue from 'vue'
import { review_score_values, get_beds } from '@bookingv3/resources'
import { get_availability } from '@utilities/commons'
const decimals = 2

export function markup(price) {

  let mu = JSON.parse(atob(Vue.prototype.$config.mu)),
    markups = mu['DEFAULT'] || [],
    pricerange_markup = 0,
    customer_markup = number(mu.ADD.p || 0.1),
    mu_percent = customer_markup,
    mu_display_percent = (mu.DISPLAY) ? mu.DISPLAY.p : 0

  markups.forEach(m => {
    if (largerEq(number(price), number(m.min))) {
      pricerange_markup = number(m.p)
    } else {
      return
    }
  })

  if (Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu))
  } else {
    mu_percent = round(sum(pricerange_markup, customer_markup), 3) // percentuale markup 3 decimali
  }


  let markup = round(multiply(price, mu_percent), decimals)
  let live_price = round(sum(price, markup), decimals)

  let display_markup = round(multiply(price, mu_display_percent), decimals)
  let display_price = round(sum(price, display_markup), decimals)

  if (smaller(live_price, price)) live_price = price

  /*window.console.table({
    price: price,
    mu_percent: mu_percent,
    markup: markup,
    live_price: live_price,
    display_price: display_price,
  })*/


  return {
    markup: String(markup), // ammontare del markup
    live_price: String(live_price), // markup su prezzo netto
    display_price: String(display_price), // markup "finto" su prezzo commissionabile
  }

}

export function reverse_markup(live_price) {
  let mu = JSON.parse(atob(Vue.prototype.$config.mu));
  let markups = mu["DEFAULT"] || [];
  let customer_markup = number(mu.ADD.p || 0.1);
  let mu_percent = customer_markup;
  let pricerange_markup = 0;

  if (Vue.prototype.$config.forced_mu) {
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));

    let price = number(live_price) / (1 + mu_percent);
    price = round(price, decimals);

    return {
      price: String(price),
      mu_percent: mu_percent,
      customer_markup: customer_markup,
    };
  }

  let sorted_markups = [...markups].sort(
    (a, b) => number(b.min) - number(a.min)
  );

  for (let i = 0; i < sorted_markups.length; i++) {
    let test_pricerange_markup = number(sorted_markups[i].p);
    let test_mu_percent = round(
      sum(test_pricerange_markup, customer_markup),
      3
    );

    let test_price = number(live_price) / (1 + test_mu_percent);
    test_price = round(test_price, decimals);

    if (largerEq(number(test_price), number(sorted_markups[i].min))) {
      let markup_test = round(multiply(test_price, test_mu_percent), decimals);
      let live_price_test = round(sum(test_price, markup_test), decimals);

      if (smaller(live_price_test, test_price)) {
        live_price_test = test_price;
      }

      if (number(live_price_test) === number(live_price)) {
        return {
          price: String(test_price),
          mu_percent: test_mu_percent,
          pricerange_markup: test_pricerange_markup,
          customer_markup: customer_markup,
        };
      }
    }
  }

  mu_percent = customer_markup;
  let price = number(live_price) / (1 + mu_percent);
  price = round(price, decimals);

  return {
    price: String(price),
    mu_percent: mu_percent,
    pricerange_markup: pricerange_markup,
    customer_markup: customer_markup,
  };
}

export function round_up(price) {
  return round(price, decimals)
}

export function format_date_with_month(time) {
  return moment(time, ['YYYY-MM-DD', 'DD-MM-YYYY']).locale('it').format('DD MMMM YYYY')
}

export function map_markers(items, availability, sass) {
  let markers = []
  if (!items) return []
  items.forEach((item) => {
    let color = '#999999',
      z_index = 1,
      copy = ''

    if (!get_availability(number(item.price)).show_credit_alert) {
      color = sass('primary')
      z_index = 10
    }
    else {
      copy = '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>'
    }

    let stars = '',
      stars_value = number(item.stars)
    if (stars_value > 0) {
      stars += '<div class="stars">'
      for (let i = 0; i < stars_value; i++) {
        stars += '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>'
      }
      stars += '</div>'
    }

    let review_score_value = number(item.salabamScore),
      review_score = '',
      review_desc = ''
    if (review_score_value) {
      let review_score_desc = review_score_values.filter(s => { return s.value >= floor(review_score_value) })
      if (review_score_desc.length > 0) review_desc = review_score_desc.reverse()[0].short_label + '<br>'
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`
    }

    markers.push({
      color: color,
      name: item.name,
      content:
        `<div class="info-window">
              <div class="info-window__image">
                <img src="${item.imageUrl}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${item.name}</div>
                    <div class="address">${item.full_address}</div>
                  </div>
                  <div class="right">
                    <div class="price">${item.price}€</div>
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.location.latitude),
        lng: number(item.location.longitude)
      },
      icon: {
        url: 'data:image/svg+xml;base64,' + window.btoa(
          '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g filter="url(#filter0_d_1016_36)">' +
          '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
          '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
          '</g>' +
          '<g filter="url(#filter1_d_1016_36)">' +
          '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
          '</g>' +
          '<defs>' +
          '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '</defs>' +
          '</svg>'
        ),
      },
      item: item,
      z_index: z_index,
    })
  })
  return markers
}

export function map_markers_v3(items, availability, sass) {
  let markers = []
  if (!items) return []
  items.forEach((item) => {
    let color = '#999999',
      z_index = 1,
      copy = ''

    if (!get_availability(number(item.price.total)).show_credit_alert) {
      color = sass('primary')
      z_index = 10
    }
    else {
      copy = '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>'
    }

    let stars = '<div class="stars">'
    if (item.stars) {
      let stars_value = number(item.stars)
      if (stars_value > 0) {
        stars += '<div class="stars">'
        for (let i = 0; i < stars_value; i++) {
          stars += '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>'
        }
        stars += '</div>'
      }
    }
    else stars += '-</div>'

    let review_score_value = number(item.accommodations_details.salabam_score),
      review_score = '',
      review_desc = ''
    if (review_score_value) {
      let review_score_desc = review_score_values.filter(s => { return s.value >= floor(review_score_value) })
      if (review_score_desc.length > 0) review_desc = review_score_desc.reverse()[0].short_label + '<br>'
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`
    }

    const price = `€ ${get_live_price_tax_free(item)}` // live_price senza tasse di soggiorno

    markers.push({
      color: color,
      name: item.accommodations_details.name,
      content:
        `<div class="info-window">
              <div class="info-window__image">
                <img src="${item.accommodations_details.image_url}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${item.accommodations_details.name}</div>
                    <div class="address">${item.accommodations_details.address}</div>
                  </div>
                  <div class="right">
                    <div class="price">${price}€</div>
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.accommodations_details.coordinates.latitude),
        lng: number(item.accommodations_details.coordinates.longitude)
      },
      icon: {
        url: 'data:image/svg+xml;base64,' + window.btoa(
          '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g filter="url(#filter0_d_1016_36)">' +
          '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
          '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
          '</g>' +
          '<g filter="url(#filter1_d_1016_36)">' +
          '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
          '</g>' +
          '<defs>' +
          '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '</defs>' +
          '</svg>'
        ),
      },
      price_label: price,
      item: item,
      z_index: z_index,
    })
  })
  return markers
}

export function get_live_price_tax_free(property) {
  // live_price senza tasse di soggiorno
  return round_up(markup(property.products[0].price.total_tax_free).live_price)
}

export function format_beds(bed_options) {
  let beds = []

  bed_options.forEach(bed_option => {
    bed_option.bed_configurations.forEach(bed_conf => {
      const arr_configuration = bed_conf.configuration.map(conf =>
        get_beds(conf.bed_type, conf.number_of_beds)
      )
      beds.push(arr_configuration)
    })
  })

  return beds = beds.map(option => option.join(' e ')).join(' oppure ')
}

/**
 * Deprecata in api v4 - usare direttamente pricing.total_tax_free con markup()
 */
// export function get_live_price_no_tax(pricing, book_price = null, extra_charges = null) {
//   if (!pricing) return {}
//   /* TODO scorporo tasse:
//   * - deprecato (spostato a backend) su V4
//   * - lasciato per retrocompatibilità V3
//   * - nelle V4 al posto di pricing.book verrà pricing.total_tax_free con tasse già scorporate a BE
//   */
//   const charges = extra_charges !== null ? extra_charges : pricing.extra_charges,
//     tax_22 = charges.included.find(tax => tax.charge === 22),
//     base_price = book_price !== null ? book_price : pricing.book,
//     tax_excluded_price = subtract(number(base_price), (tax_22 && tax_22.total_amount) ? tax_22.total_amount : 0)
//   /* fine TODO scorporo tasse */
//   return round_up(markup(tax_excluded_price).live_price) // live_price senza tasse di soggiorno
// }

export function get_public_price(price) {
  if (!price) return null

  return round_up(markup(price).live_price) // live_price senza tasse di soggiorno
}

/**
 * Normalizza l'allocation di una camera prima di inviarla alle API di Booking.com
 * (preview/create). È il puro ESECUTORE del fold bambini→adulti: applica la
 * conversione se e solo se il flag `children_as_adults` è già true.
 *
 * NON decide QUANDO convertire: la decisione (prodotto con children === null E
 * capiente) vive in `build_allocation_products`, che ha accesso al prodotto e
 * alla sua capienza — informazioni non presenti nell'allocation. Vedi
 * `build_allocation_products` per la regola di attivazione del flag (TAZ-886).
 *
 * Quando `children_as_adults` è true i bambini vengono sommati a
 * `number_of_adults` e l'array `children` viene svuotato; altrimenti l'allocation
 * resta invariata. L'occupancy mostrata all'utente NON viene toccata: la
 * normalizzazione avviene solo sul payload in uscita.
 *
 * @param {Object} allocation - { number_of_adults, children, children_as_adults }
 * @returns {Object} allocation normalizzata { number_of_adults, children }
 */
export function normalize_allocation(allocation) {
  const { number_of_adults, children, children_as_adults } = allocation

  if (children_as_adults) {
    return {
      number_of_adults: number_of_adults + children.length,
      children: []
    }
  }

  return { number_of_adults, children }
}

/**
 * Totale ospiti di una camera. Gestisce sia l'occupancy della ricerca
 * (`children` = array di età, es. [6]) sia il maximum_occupancy di un prodotto
 * (`children` = array di fasce con `.total`, oppure null).
 *
 * @param {Object} room - { adults, children }
 * @returns {number}
 */
export function count_guests(room) {
  const adults = room.adults || 0
  const children = room.children
    ? room.children.reduce((acc, child) => acc + (child.total ? child.total : 1), 0)
    : 0
  return adults + children
}

/**
 * Costruisce la lista prodotti+allocation per la preview/checkout a partire dai
 * prodotti realmente selezionati (`solution.rooms`) e dall'occupancy della
 * ricerca (`solution.occupancy`), SENZA passare da `match_rooms`.
 *
 * Abbina 1:1 le camere-occupancy e i prodotti selezionati ordinati per numero di
 * ospiti crescente (zip posizionale): ogni istanza di prodotto riceve
 * l'allocation di una camera della ricerca, con id corretto e distinto. La
 * verifica di capienza è delegata a Booking.com, che restituisce
 * `occupancy_mismatch` sui prodotti in eccesso.
 *
 * L'`index` è l'ordine originale della camera nella ricerca, usato dal display
 * come "Gruppo N".
 *
 * Qui si DECIDE il flag `children_as_adults` (TAZ-886): true quando il prodotto
 * assegnato non definisce fasce bambini (children === null) E è capiente per
 * ospitare tutti gli ospiti come adulti (adulti + n° bambini <= product.adults).
 * L'ESECUZIONE del fold avviene poi in `normalize_allocation` (che legge solo il
 * flag). La decisione sta qui perché serve il prodotto e la sua capienza, dati
 * non disponibili in `normalize_allocation`.
 *
 * @param {Array} occupancy - camere della ricerca: [{ adults, children:[età] }]
 * @param {Array} rooms - camere selezionate: [{ products: { <id>: { id, price_selected:{qty}, maximum_occupancy } } }]
 * @returns {Array} [{ id, allocation: { number_of_adults, children, index, children_as_adults } }]
 */
export function build_allocation_products(occupancy, rooms) {
  // occupancy della ricerca, con indice originale per il display, ordinata per dimensione
  const occ_rooms = (occupancy || [])
    .map((occ, index) => ({ adults: occ.adults, children: occ.children, index }))
    .sort((a, b) => count_guests(a) - count_guests(b))

  // prodotti selezionati espansi per quantità, ordinati per dimensione
  const prod_rooms = [];
  (rooms || []).forEach(room => {
    Object.values(room.products).forEach(product => {
      for (let i = 0; i < product.price_selected.qty; i++) {
        prod_rooms.push({
          id: product.id,
          adults: product.maximum_occupancy.adults,
          children: product.maximum_occupancy.children
        })
      }
    })
  })
  prod_rooms.sort((a, b) => count_guests(a) - count_guests(b))

  // zip posizionale occupancy ↔ prodotto
  return occ_rooms.map((occ, i) => {
    const product = prod_rooms[i]
    const children_count = occ.children ? occ.children.length : 0

    // I bambini vanno conteggiati come adulti paganti (TAZ-886) SOLO se il
    // prodotto assegnato non definisce fasce bambini (children === null) E la
    // sua capienza adulti basta a ospitarli tutti come adulti (camera capiente).
    // Se il prodotto ha fasce bambini, o se non è capiente, l'allocation resta
    // invariata e sarà Booking.com a segnalare l'occupancy_mismatch.
    const children_as_adults = !!product && !product.children && occ.adults + children_count <= product.adults

    return {
      id: product ? product.id : undefined,
      allocation: {
        number_of_adults: occ.adults,
        children: occ.children,
        index: occ.index,
        children_as_adults
      }
    }
  })
}

/**
 * Formatta l'oggetto `occupancy_mismatch` restituito da /orders/preview in
 * stringhe leggibili per l'utente.
 *
 * `occupancy_mismatch` è un avviso (non è un errore) che Booking.com restituisce
 * quando gli ospiti richiesti superano la capacità della camera. Ripartisce gli
 * ospiti in:
 * - allocated: ospiti che la camera può ospitare;
 * - unallocated: ospiti che eccedono la capienza.
 *
 * In ogni gruppo `children` è `null` quando non ci sono bambini, altrimenti un
 * array di età (es. [6, 3]) che viene reso in linguaggio naturale, es.
 * "2 bambini (6 e 3 anni)". Restituisce `null` quando non c'è mismatch, così i
 * chiamanti possono usarlo direttamente come guardia (v-if).
 *
 * @param {Object|null} occupancy_mismatch - { allocated, unallocated } o null
 * @returns {{ allocated: string, unallocated: string }|null}
 */
export function format_occupancy_mismatch(occupancy_mismatch) {
  if (!occupancy_mismatch) return null

  // trasforma un gruppo { number_of_adults, children } in "X adulti e Y bambini"
  const format_group = (group) => {
    if (!group) return ''

    const adults = group.number_of_adults || 0
    const children = group.children ? group.children.length : 0

    const parts = []
    if (adults > 0) parts.push(`${adults} ${adults === 1 ? 'adulto' : 'adulti'}`)
    if (children > 0) {
      // età in linguaggio naturale: "6 anni", "6 e 3 anni", "6, 3 e 8 anni"
      const ages = group.children
      const ages_label = ages.length > 1
        ? `${ages.slice(0, -1).join(', ')} e ${ages[ages.length - 1]}`
        : `${ages[0]}`
      parts.push(`${children} ${children === 1 ? 'bambino' : 'bambini'} (${ages_label} anni)`)
    }

    return parts.join(' e ')
  }

  return {
    allocated: format_group(occupancy_mismatch.allocated),
    unallocated: format_group(occupancy_mismatch.unallocated),
  }
}

/**
 * Formatta un elenco di età in linguaggio naturale, con label singolare/plurale.
 * Le età vengono ordinate crescenti, es. "3 anni", "3 e 5 anni", "3, 5 e 7 anni".
 *
 * @param {Array<number>} ages - età dei bambini
 * @param {String} singular - label per un solo bambino, es. "bambino"
 * @param {String} plural - label per più bambini, es. "bambini"
 * @returns {{ label: String, text: String }}
 */
function format_children_ages(ages, singular, plural) {
  const sorted = [...ages].sort((a, b) => a - b)
  const label = ages.length > 1 ? plural : singular
  // "anno" solo se c'è un unico bambino di 1 anno, altrimenti sempre "anni"
  const age_label = ages.length === 1 && sorted[0] === 1 ? 'anno' : 'anni'
  const text = sorted.length === 1
    ? `${sorted[0]} ${age_label}`
    : `${sorted.slice(0, -1).join(', ')} e ${sorted[sorted.length - 1]} ${age_label}`
  return { label, text }
}

/**
 * Formatta un gruppo di ospiti in linguaggio naturale, es.
 * "2 adulti e 2 bambini di 2 e 4 anni".
 *
 * @param {Number} adults - numero di adulti
 * @param {Array<number>} children_ages - età dei bambini
 * @returns {String}
 */
export function format_guests(adults, children_ages) {
  const parts = []

  if (adults > 0) parts.push(`${adults} ${adults > 1 ? 'adulti' : 'adulto'}`)

  if (children_ages && children_ages.length) {
    const { label, text } = format_children_ages(children_ages, 'bambino', 'bambini')
    parts.push(`${children_ages.length} ${label} di ${text}`)
  }

  return parts.join(' e ')
}

/**
 * Capienza massima di un prodotto, indipendente dagli ospiti della ricerca:
 * gli adulti e il totale dei posti bambino di tutte le fasce d'età, senza
 * riferimento alle età, es. "2 adulti e 2 bambini".
 *
 * @param {Object} maximum_occupancy - { adults, children: [{ total }] | null }
 * @returns {String}
 */
export function format_max_occupancy(maximum_occupancy) {
  const { adults, children } = maximum_occupancy || {}

  const children_total = (children || []).reduce(
    (total, child) => total + (child.total || 0),
    0
  )

  const parts = []
  if (adults > 0) parts.push(`${adults} ${adults > 1 ? 'adulti' : 'adulto'}`)
  if (children_total > 0) {
    parts.push(`${children_total} ${children_total > 1 ? 'bambini' : 'bambino'}`)
  }

  return parts.join(' e ')
}

/**
 * Calcola l'occupancy effettiva di un prodotto confrontando i bambini della
 * ricerca con le fasce d'età accettate dal prodotto.
 *
 * Input:
 * - maximum_occupancy: capacità del prodotto con fasce d'età bambini, es:
 *   { adults: 2, children: [{from_age: 0, to_age: 5, total: 2, free_stay: true}] }
 * - occupancy: camere della ricerca, es. [{adults: 2, children: [3, 7]}]
 *
 * Output:
 * - adults: numero adulti supportati dal prodotto
 * - children: numero bambini della ricerca che rientrano nelle fasce d'età
 * - children_free: numero bambini con soggiorno gratuito
 * - guests: capienza in linguaggio naturale, es. "2 adulti e 2 bambini di 3 e 7 anni"
 * - free_stay_message: es. "Soggiorno gratis per il bambino di 3 anni"
 *
 * @param {Object} maximum_occupancy - { adults, children }
 * @param {Array} occupancy - camere della ricerca: [{ adults, children:[età] }]
 * @returns {{ adults: Number, children: Number, children_free: Number, guests: String, free_stay_message: String }}
 */
export function format_product_occupancy(maximum_occupancy, occupancy) {
  const { adults, children } = maximum_occupancy
  // età dei bambini effettivamente matchati e di quelli con soggiorno gratuito
  const matched_ages = []
  const free_ages = []

  // Verifica quali bambini della ricerca sono compatibili con le fasce d'età del prodotto
  if (children) {
    // Copia le fasce per non mutare i dati originali (total viene decrementato)
    const available_children = children.map(child => ({...child}))

    for (const pax of (occupancy || [])) {
      for (const age of (pax.children || [])) {
        // Trova una fascia d'età disponibile che accetti questo bambino
        const slot = available_children.find(
          child => age >= child.from_age && age <= child.to_age && child.total > 0
        )
        if (slot) {
          // decrementa la disponibilità della fascia e traccia l'età matchata
          slot.total = subtract(slot.total, 1)
          matched_ages.push(age)
          if (slot.free_stay) free_ages.push(age)
        }
      }
    }
  }

  let free_stay_message = ''
  if (free_ages.length > 0) {
    const { label, text } = format_children_ages(free_ages, 'il bambino', 'i bambini')
    free_stay_message = `Soggiorno gratis per ${label} di ${text}`
  }

  return {
    adults,
    children: matched_ages.length,
    children_free: free_ages.length,
    guests: format_guests(adults, matched_ages),
    free_stay_message,
  }
}

/**
 * Testo dell'avviso di capienza superiore, con accordo singolare/plurale sugli
 * ospiti per cui si sta prenotando.
 *
 * @param {Number} adults
 * @param {Number} children
 * @returns {String}
 */
function overcapacity_message(adults, children) {
  const adulti = `${adults} ${adults === 1 ? 'adulto' : 'adulti'}`

  // la parte bambini è omessa quando non ce ne sono
  const bambini = children > 0
    ? ` e ${children} ${children === 1 ? 'bambino' : 'bambini'}`
    : ''

  return `La soluzione prevede una capienza massima superiore, ma stai prenotando per ${adulti}${bambini}. Eventuali ospiti aggiuntivi richiedono la conferma della struttura e possono comportare supplementi. Per prenotare per più ospiti, effettua una nuova ricerca.`
}

/**
 * Avviso mostrato quando la soluzione ha una capienza massima superiore al
 * numero di ospiti per cui si sta effettivamente prenotando (la ricerca).
 *
 * Serve a chiarire che, pur avendo scelto ad es. una quadrupla, la prenotazione
 * vale per gli ospiti della ricerca (es. 2) e non per la capienza massima della
 * camera.
 *
 * Confronta il totale ospiti della ricerca (`solution.occupancy`) con il totale
 * ospiti della capienza massima (somma di `maximum_occupancy.total` su tutti i
 * prodotti selezionati, moltiplicata per la quantità scelta).
 *
 * @param {Object} solution - { occupancy, rooms }
 * @returns {String|null} null se non c'è capienza in eccesso
 */
export function format_overcapacity_notice(solution) {
  // occupancy della ricerca: per quanti ospiti si sta prenotando
  const booked = (solution.occupancy || []).reduce((total, item) => {
    total.adults += item.adults
    total.children += item.children.length
    return total
  }, { adults: 0, children: 0 })

  // capienza massima totale della soluzione (somma dei total dei prodotti)
  const capacity_total = (solution.rooms || []).reduce((total, room) => total
    + Object.values(room.products).reduce(
      (acc, product) => acc + multiply(product.maximum_occupancy.total, product.price_selected.qty),
      0
    ), 0)

  // mostra l'avviso solo se la capienza supera gli ospiti prenotati
  if (capacity_total <= booked.adults + booked.children) return null

  return overcapacity_message(booked.adults, booked.children)
}

/**
 * Stesso avviso, ma per la singola camera: confronta gli ospiti del gruppo
 * assegnato (`allocation`) con la capienza massima di quel prodotto.
 *
 * @param {Object} allocation - { number_of_adults, children }
 * @param {Object} maximum_occupancy - { total }
 * @returns {String|null} null se non c'è capienza in eccesso
 */
export function format_allocation_overcapacity_notice(allocation, maximum_occupancy) {
  if (!allocation || !maximum_occupancy) return null

  const adults = allocation.number_of_adults || 0
  const children = allocation.children ? allocation.children.length : 0

  if (maximum_occupancy.total <= adults + children) return null

  return overcapacity_message(adults, children)
}

const TRACKABLE_CHARGE_IDS = [22, 23, 142, 154]

export function extract_trackable_extra_charges(extra_charges) {
  if (!extra_charges || typeof extra_charges !== 'object') return []

  const mismatches = []
  Object.entries(extra_charges).forEach(([bucket, list]) => {
    if (!Array.isArray(list)) return
    list.forEach(item => {
      if (!item || !TRACKABLE_CHARGE_IDS.includes(item.charge)) return
      if (!item.chargeable_online) return
      const raw_amount = item.total_amount && item.total_amount.booker_currency
      mismatches.push({
        id: item.charge,
        amount: raw_amount != null ? Number(raw_amount) : null,
        bucket,
      })
    })
  })
  return mismatches
}
